// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"8f3e3e4f","212":"4f816635","882":"c9ef8dfd","910":"9978b64a","912":"c5cb9cc5"}[chunkId] + ".chunk.css";
};